// Generated by psc version 0.10.2
"use strict";
var Control_Biapply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-bifunctors/src/Control/Biapply.purs");
var Biapplicative = function (__superclass_Control$dotBiapply$dotBiapply_0, bipure) {
    this["__superclass_Control.Biapply.Biapply_0"] = __superclass_Control$dotBiapply$dotBiapply_0;
    this.bipure = bipure;
};
var bipure = function (dict) {
    return dict.bipure;
};
module.exports = {
    Biapplicative: Biapplicative, 
    bipure: bipure
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-bifunctors/src/Control/Biapplicative.purs
// module id = 97
// module chunks = 0